import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import { useState } from 'react';


import banner1 from './images/broad2.png';
import banner2 from './images/broad1.jpg';
import banner3 from './images/broad3.jpg';
import banner4 from './images/broad4.jpg';
import styles from './index.module.css';
import 'swiper/css';

const banners = [banner1, banner2, banner3, banner4];

let t = 0;
const Banner = () => {
    const [swiperInstance, setSwiperInstance] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <div className={styles['page']}>
            <div
                style={{
                    position: 'absolute',
                    bottom: '10%',
                    zIndex: 99,
                }}
                className={styles['banner-btn']}
            >
                {banners.map((_, index) => (
                    <div onClick={() => {
                        clearTimeout(t);
                        swiperInstance.slideTo(index);
                        t = setTimeout(() => {
                            swiperInstance.autoplay.start();
                        }, 3000);
                    }}>
                        <div 
                        className={styles['banner-btn-title']}
                        style={{
                            fontWeight: activeIndex === index ? 'bold' : undefined
                        }}
                        >0{index + 1}</div>
                        <div className={styles['banner-btn-icon']}>
                            {activeIndex === index && (
                                <div className={styles['icon']}></div>
                            )}
                        </div>

                    </div>
                ))}
            </div>

            <Swiper
                onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                onSwiper={setSwiperInstance}
                modules={[Autoplay]}
                autoplay
            >
                {banners.map((item) => (
                    <SwiperSlide>
                        <div
                            className={styles['swiper-item']}
                        >
                            <img src={item} height='100%' className={styles['img']} alt=''/>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default Banner;